import axios from "axios";
import { useEffect, useState } from "react";

const Filters = ({ initialFilters, onChange, onSubmit, onReset }) => {
  const [localFilters, setLocalFilters] = useState({});
  const [rodzajeDokumentu, setRodzajeDokumentu] = useState([]);
  const [tematyDokumentu, setTematyDokumentu] = useState([]);
  const [typyUrzedu, setTypyUrzedu] = useState([]);
  const [wojewodztwa, setWojewodztwa] = useState([]);
  const [powiaty, setPowiaty] = useState([]);
  const [gminy, setGminy] = useState([]);
  const [obszary, setObszary] = useState({
    powiaty: true,
    gminy: true
  });
  useEffect(() => { setLocalFilters(initialFilters); }, [initialFilters])
  useEffect(() => {
    const rd = async () => {
      try {
        const response = await axios.get(`/apiv1/rodzaje-dokumentu`, {});
        setRodzajeDokumentu(response.data.data);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };
    const td = async () => {
      try {
        const response = await axios.get(`/apiv1/tematy-dokumentu`, {});
        setTematyDokumentu(response.data.data);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };
    const tu = async () => {
      try {
        const response = await axios.get(`/apiv1/typy-urzedu`, {});
        setTypyUrzedu(response.data.data);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };
    const woj = async () => {
      try {
        const response = await axios.get(`/apiv1/wojewodztwa`, {});
        setWojewodztwa(response.data.data);
      } catch (error) {
        console.error('BĹ‚Ä…d podczas pobierania dokumentĂłw:', error);
      }
    };
    rd();
    td();
    tu();
    woj();
  }, []);
  const fetchPowiaty = async (wojewodztwoId) => {
    try {
      const response = await axios.get(`/apiv1/powiaty/${wojewodztwoId}`);
      setPowiaty(response.data.data);
    } catch (error) {
      console.error("Błąd podczas pobierania powiatów:", error);
      setPowiaty([]);
    }
  };

  const fetchGminy = async (powiatId) => {
    try {
      const response = await axios.get(`/apiv1/gminy/${powiatId}`);
      setGminy(response.data.data);
    } catch (error) {
      console.error("Błąd podczas pobierania gmin:", error);
      setGminy([]);
    }
  };
  const handleChange = async (e) => {
    const { name, value, type, checked } = e.target;
    let updatedFilters = {
      ...localFilters,
      [name]: type === "checkbox" ? checked : value,
    };
    if (name === "wojewodztwo") {
      updatedFilters = { ...updatedFilters, powiat: "", gmina: "" };
      setGminy([]);
      if (value === "17" || value === "") {
        setPowiaty([]);
        setObszary({ powiaty: true, gminy: true });
      } else {
        await fetchPowiaty(value);
        setObszary({ powiaty: false, gminy: true });
      }
    }
    if (name === "powiat") {
      updatedFilters = { ...updatedFilters, gmina: "" };
      if (value !== "") {
        await fetchGminy(value);
        setObszary({ powiaty: false, gminy: false });
      } else {
        setObszary({ powiaty: false, gminy: true });
      }
    }
    setLocalFilters(updatedFilters);
    onChange(updatedFilters);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onChange(localFilters);
    onSubmit();
  };

  const handleReset = (e) => {
    e.preventDefault();
    setLocalFilters({});
    onReset();
  };
  const isDisabled = (field) => false;
  const disabledClass = (field) => (isDisabled(field) ? "disabled-status" : "");

  return (
    <form className="filters-container" onSubmit={handleSubmit}>
      <h2>Wyszukiwanie</h2>

      <div className="filters-row-top">
        <div className="filters-row">
          <div className="form-box">
            <label htmlFor="numer">Numer porządkowy</label>
            <input
              id="numer"
              name="numer"
              value={localFilters.numer || ""}
              onChange={handleChange}
              placeholder="Numer porządkowy"
            />
          </div>

          <div className="form-box">
            <label htmlFor="rok">Rok wydania karty</label>
            <input
              id="rok"
              name="rok"
              value={localFilters.rok || ""}
              onChange={handleChange}
              placeholder="Rok wydania karty"
            />
          </div>

          <div className="form-box">
            <label htmlFor="znak">Znak sprawy</label>
            <input
              id="znak"
              name="znak"
              value={localFilters.znak || ""}
              onChange={handleChange}
              placeholder="Znak sprawy"
            />
          </div>

          <div className="form-box">
            <label htmlFor="rodzajDokumentu">Rodzaj dokumentu</label>
            <select
              id="rodzajDokumentu"
              name="rodzajDokumentu"
              value={localFilters.rodzajDokumentu || ""}
              onChange={handleChange}
            >
              <option value="">Wybierz rodzaj dokumentu</option>
              {rodzajeDokumentu.map((row, index) => (
                <option key={index} value={row.ID_DICTIONARY_ITEM}>{row.NAME}</option>
              ))}
            </select>
          </div>

          <div className="form-box">
            <label htmlFor="tematDokumentu">Temat dokumentu</label>
            <select
              id="tematDokumentu"
              name="tematDokumentu"
              value={localFilters.tematDokumentu || ""}
              onChange={handleChange}
            >
              <option value="">Wybierz temat dokumentu</option>
              {tematyDokumentu.map((row, index) => (
                <option key={index} value={row.ID_DICTIONARY_ITEM}>{row.NAME}</option>
              ))}
            </select>
          </div>

          <div className="form-box">
            <label htmlFor="typUrzedu">Typ urzędu</label>
            <select
              id="typUrzedu"
              name="typUrzedu"
              value={localFilters.typUrzedu || ""}
              onChange={handleChange}
            >
              <option value="">Wybierz typ urzędu</option>
              {typyUrzedu.map((row, index) => (
                <option key={index} value={row.ID_DICTIONARY_ITEM}>{row.NAME}</option>
              ))}
            </select>
          </div>

          <div className="form-box">
            <label htmlFor="urzad">Nazwa urzędu</label>
            <input
              id="urzad"
              name="urzad"
              value={localFilters.urzad || ""}
              onChange={handleChange}
              placeholder="Nazwa urzędu"
            />
          </div>
        </div>

        <div className="filters-row">
          <div className="form-box">
            <label htmlFor="tytul">Nazwa dokumentu</label>
            <input
              id="tytul"
              name="tytul"
              value={localFilters.tytul || ""}
              onChange={handleChange}
              placeholder="Nazwa dokumentu"
              disabled={isDisabled("tytul")}
              className={disabledClass("tytul")}
            />
          </div>

          <div className="form-box">
            <label htmlFor="wytworzyl">Dokument wytworzył</label>
            <input
              id="wytworzyl"
              name="wytworzyl"
              value={localFilters.wytworzyl || ""}
              onChange={handleChange}
              placeholder="Dokument wytworzył"
              disabled={isDisabled("wytworzyl")}
              className={disabledClass("wytworzyl")}
            />
          </div>

          <div className="form-box">
            <label htmlFor="zatwierdzil">Dokument zatwierdził</label>
            <input
              id="zatwierdzil"
              name="zatwierdzil"
              value={localFilters.zatwierdzil || ""}
              onChange={handleChange}
              placeholder="Dokument zatwierdził"
              disabled={isDisabled("zatwierdzil")}
              className={disabledClass("zatwierdzil")}
            />
          </div>

          <div className="form-box">
            <div className="date-field">
              <label htmlFor="dataDokumentuOd" >Data dokumentu:</label>
              <input
                id="dataDokumentuOd"
                type="date"
                name="dataDokumentuOd"
                value={localFilters.dataDokumentuOd || ""}
                onChange={handleChange}
                disabled={isDisabled("dataDokumentu")}
                className={disabledClass("dataDokumentu")}
              />
              <span className="date-spacer">do</span>
              <input
                aria-label="Data dokumentu do"
                id="dataDokumentuDo"
                type="date"
                name="dataDokumentuDo"
                value={localFilters.dataDokumentuDo || ""}
                onChange={handleChange}
                disabled={isDisabled("dataDokumentu")}
                className={disabledClass("dataDokumentu")}
              />
            </div>
          </div>

          <div className="form-box">
            <div className="date-field">
              <label htmlFor="dataZatwierdzeniaOd">Data zatwierdzenia:</label>
              <input
                id="dataZatwierdzeniaOd"
                type="date"
                name="dataZatwierdzeniaOd"
                value={localFilters.dataZatwierdzeniaOd || ""}
                onChange={handleChange}
                disabled={isDisabled("dataZatwierdzenia")}
                className={disabledClass("dataZatwierdzenia")}
              />
              <span className="date-spacer">do</span>
              <input
                aria-label="Data zatwierdzenia do"
                id="dataZatwierdzeniaDo"
                type="date"
                name="dataZatwierdzeniaDo"
                value={localFilters.dataZatwierdzeniaDo || ""}
                onChange={handleChange}
                disabled={isDisabled("dataZatwierdzenia")}
                className={disabledClass("dataZatwierdzenia")}
              />
            </div>
          </div>

          <div className="form-box">
            <div className="date-field">
              <label htmlFor="dataPublikacjiOd" >Data publikacji:</label>
              <input
                id="dataPublikacjiOd"
                type="date"
                name="dataPublikacjiOd"
                value={localFilters.dataPublikacjiOd || ""}
                onChange={handleChange}
              />
              <span className="date-spacer">do</span>
              <input
                aria-label="Data Publikacji do"
                id="dataPublikacjiDo"
                type="date"
                name="dataPublikacjiDo"
                value={localFilters.dataPublikacjiDo || ""}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-box">
            <label htmlFor="wyszukiwane-slowo">Wyszukiwane słowo</label>
            <input
              id="wyszukiwane-slowo"
              name="wyszukiwane-slowo"
              value={localFilters["wyszukiwane-slowo"] || ""}
              onChange={handleChange}
              placeholder="Wyszukiwane słowo"
            />
          </div>
        </div>
      </div>

      <div className="filters-row-bottom">
        <div className="form-box form-box-row">
          <label htmlFor="wojewodztwo">Obszar</label>
          <select
            id="wojewodztwo"
            name="wojewodztwo"
            value={localFilters.wojewodztwo || ""}
            onChange={handleChange}
            disabled={isDisabled("obszar")}
            className={disabledClass("obszar")}
          >
            <option value="">Wybierz województwo</option>
            {wojewodztwa.map((row, index) => (
              <option key={index} value={row.ID_DICTIONARY_ITEM}>{row.NAME}</option>
            ))}
          </select>
          <select
            aria-label="powiat"
            name="powiat"
            value={localFilters.powiat || ""}
            onChange={handleChange}
            disabled={obszary.powiaty}
            className={disabledClass("obszar")}
          >
            <option value="">Wybierz powiat</option>
            {powiaty.map((p) => (
              <option key={p.ID_DICTIONARY_ITEM} value={p.ID_DICTIONARY_ITEM}>{p.NAME}</option>
            ))}
          </select>
          <select
            aria-label="gmina"
            name="gmina"
            value={localFilters.gmina || ""}
            onChange={handleChange}
            disabled={obszary.gminy}
            className={disabledClass("obszar")}
          >
            <option value="">Wybierz gminę</option>
            {gminy.map((g) => (
              <option key={g.ID_DICTIONARY_ITEM} value={g.ID_DICTIONARY_ITEM}>{g.NAME}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="filters-row-bottom">
        <div className="form-box form-box-row">
          <label id="per_page">Ilość rekordów na stronę: </label>
          <select
            id="per_page"
            name="per_page"
            value={localFilters.per_page || ""}
            onChange={handleChange}
            disabled={isDisabled("per_page")}
            className={disabledClass("per_page")}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      <div className="filters-actions">

        <button className="blue-btn" type="submit">
          Szukaj
        </button>
        <button className="blue-btn" onClick={handleReset}>
          Resetuj
        </button>

      </div>
    </form>
  );
};

export default Filters;
